import { useQuery } from '@tanstack/react-query';
import { GetTimesheetsRequest } from 'src/api/FiretrolApiClient';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type TimesheetsForJobParams = Omit<GetTimesheetsRequest, 'jobId'>;

/** @registry Timesheets for one job, filtered by week/year/supervisor or daily context. */
export function useTimesheetsForJob(
  jobId: number | null | undefined,
  params: TimesheetsForJobParams,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.timesheets.forJob(jobId ?? -1, params),
    queryFn: ({ signal }) =>
      timesheetApiClient.getTimesheets(
        { jobId: jobId!, ...params },
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && options?.enabled !== false,
    meta: { errorContext: 'job timesheets' },
  });
}
